import { render, staticRenderFns } from "./AddMoreAssessment.vue?vue&type=template&id=3e4afbb4"
import script from "./AddMoreAssessment.vue?vue&type=script&lang=js"
export * from "./AddMoreAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports